import axios from 'axios'
import jwt from 'jwt-simple'

export const getMenu = async ({ commit }) => {
	const storage = localStorage.getItem('user')
	if(!storage) {
		return
	}
	commit('setMenu', [])
	localStorage.removeItem('_menu')
	const dados = JSON.parse(jwt.decode(storage, 'vox'))
	const item = await axios.get('/menu', {
		params: { id: dados.id }
	})
	localStorage.setItem('_menu', item.data[0].menu)
	commit('setMenu', JSON.parse(item.data[0].menu))
}

export const getUser = ({ commit }, user) => {
	commit('setUser', user)
}

export const getLogsTotal = ({ commit }, id) => {
	axios.get(`/logs/count/${id}`).then(resp => {
		axios.get(`/logs/last/${id}`).then(dados => {
			commit('setLogs', dados.data)
		})
		commit('setLogsTotal', resp.data.total)
	})
}
